<template>
	<c-loader class="c-project-list" v-if="loading" />
	<ul :class="modifier ? 'c-services-list c-services-list--' + modifier : 'c-services-list'" v-else>
		<li class="c-services-list__item" v-for="service in services">
			<router-link
				class="c-services-list__link"
				:key="service.slug"
				:to="settings.currentLang === 'en-us' ? '/en/service/' + service.slug : '/service/' + service.slug">
				<span class="c-services-list__image">
					<img v-if="modifier === 'inverted'" :src="service.iconInverted" alt="Service Icon">
					<img v-else :src="service.icon" alt="Service Icon">
				</span>
				<span class="c-services-list__label">{{ service.title }}</span>
			</router-link>
		</li>
	</ul>
</template>

<script>
import CLoader from '@/components/Loader'

export default {
	name: 'services-list',
	components: {
		CLoader
	},
	props: ['modifier'],
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		loading() {
			return this.$store.state.services.loading
		},
		services() {
			return this.$store.state.services.servicesList[this.settings.currentLang]
		}
	},
	watch: {
		'$route': function() {
			this.fetchServicesData()
		}
	},
	beforeMount() {
		this.fetchServicesData()
	},
	methods: {
		fetchServicesData() {
			this.$store.dispatch('loadServices', this.settings.currentLang)
		}
	}
}
</script>

<style lang="scss">
@import "../assets/css/helpers";

.c-services-list {
	display: flex;
	flex-wrap: wrap;

	&__item {
		width: 100%;
		text-align: left;

		a {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			color: $colorBrandSecondary;
			font-weight: 600;
			text-decoration: none;

			.c-services-list__label {
				display: block;
				font-size: 1rem;
				// width: 60%;
				transition: .2s color ease-out, .2s transform ease-out;
			}
		}
		img {
			display: block;
			width: 100%;
			height: auto;
		}

		@include mq($from: medium) {
			width: 33.3%;
			text-align: center;

			a {
				justify-content: center;

				&:hover {
					.c-services-list__label {
						color: $colorHighlight;
						transform: translateY(-10px);
					}
				}
				.c-services-list__label {
					width: 100%;
					flex-shrink: 0;
					font-size: 1.3rem;
				}
			}
			.c-services-list__image {
				width: 80%;
			}
			img {
				margin: 0 auto;
				margin-bottom: 1rem;
			}
		}
	}
	&__image {
		width: 40%;
		flex-shrink: 0;
	}

	.is-active {
		opacity: 0.5;
		pointer-events: none;
	}

	&--inverted {
		.c-services-list__item {
			a {
				color: $colorWhite;
			}
		}
	}

}
</style>



// WEBPACK FOOTER //
// ServicesList.vue?f46e3a9c